import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useToken from '../common/helper/useToken';
import { useSelector } from 'react-redux';

interface MenuItem {
  name?: string;
  route?: string;
}

interface MenuState {
  items: MenuItem[] | null;
}

interface RootState {
  menu: MenuState;
}

const PublicRoutes = () => {
  const { token } = useToken();
  const main_menu = useSelector((state: RootState) => state.menu.items);
  const [routTo, setRoutTo] = useState<string>('');

  useEffect(() => {
    if (main_menu && Array.isArray(main_menu)) {
      const firstRoute = main_menu.find(
        (item) => item?.route && typeof item.route === 'string'
      );
      if (firstRoute) {
        setRoutTo(`/${firstRoute.route}`);
      }
    }
  }, [main_menu]);

  useEffect(() => {
    const script = document.getElementById(
      'c10b159f-c584-4f49-8192-66738e4be615'
    );
    if (script) {
      script.remove();
      window.location.reload();
    }
  }, []);

  // When a token exists but the menu hasn't resolved yet, routTo is still ''.
  // Rendering <Navigate to='' /> causes a blank page / redirect loop on /login.
  // Hold rendering until we know where to send the user.
  if (token && !routTo) return null;

  return token ? (
    <Navigate to={routTo} />
  ) : (
    <div className='zl-force-light-theme'>
      <Outlet />
    </div>
  );
};

export default PublicRoutes;
